<template>
  <section class="features-grid">
    <div class="feature-card" v-for="(feature, index) in features" :key="index">
      <div class="feature-content">
        <h3>{{ feature.title }}</h3>
        <p v-if="feature.descriptionHtml" v-html="feature.descriptionHtml"></p>
        <p v-else>{{ feature.description }}</p>
      </div>
      <div class="feature-image">
        <img :src="feature.imageSrc" :alt="feature.imageAlt" />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FeaturesGrid',
  props: {
    features: {
      type: Array,
      required: true,
      validator: function (value) {
        return value.every(feature => 
          feature.title && 
          (feature.description || feature.descriptionHtml) &&
          feature.imageSrc && 
          feature.imageAlt
        )
      }
    }
  }
}
</script>

<style scoped>
/* Features Grid - 现代化卡片设计 */
.features-grid {
  padding: 40px 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.feature-card {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 50px;
  margin-bottom: 40px;
  align-items: center;
  background: white;
  padding: 40px;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
  transition: transform 0.3s ease;
}

.feature-card:hover {
  transform: translateY(-5px);
}

.feature-card:nth-child(even) {
  direction: rtl;
}

.feature-card:nth-child(even) .feature-content {
  direction: ltr;
}

.feature-content h2 {
  margin-bottom: 20px;
  color: #2c3e50;
  font-weight: 700;
}

.feature-content p {
  font-size: 1.1rem;
  line-height: 1.6;
  color: #555;
}

.feature-content ::v-deep a {
  color: #2563eb;
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 3px;
  transition: color 0.2s ease, background-color 0.2s ease;
}

.feature-content ::v-deep a:hover {
  color: #0f766e;
  background-color: #ecfeff;
}

.feature-image {
  width: 230px;
  height: 230px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.feature-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 15px;
  transition: transform 0.3s ease;
}

.feature-image img:hover {
  transform: scale(1.05);
}

/* Responsive Design */
@media (max-width: 768px) {
  .feature-card {
    grid-template-columns: 1fr;
    display: flex;
    gap: 30px;
    flex-direction: column-reverse;
    text-align: center;
  }
  
  .feature-card:nth-child(even) {
    direction: ltr;
  }
  
  .feature-card:nth-child(even) .feature-content {
    direction: ltr;
  }
}
</style>
